/// <amd-module name="Tfs/Frame/Components/MyWork/MyWork" />
import * as React from "react";
import * as Resources from "Tfs/Frame/Resources";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";
import { ExpandableContainer, IExpandable } from "VSSUI/Expandable";
import { Button } from "VSSUI/Button";

export class MyWork extends React.Component<{}> {
    public render(): JSX.Element {
        return (
            <ScreenSizeConditional condition={screenSize => screenSize > ScreenSize.xsmall}>
                <ExpandableContainer
                    excludeFocusZone={true}
                    expandableId="my-work-panel"
                    renderCallout={this.renderDropdown}
                    role="menuitem"
                >
                    <Button
                        ariaLabel={Resources.MyWorkLabel}
                        iconProps={{ iconName: "CheckList" }}
                        subtle={true}
                        tooltipProps={{ text: Resources.MyWorkLabel }}
                    />
                </ExpandableContainer>
            </ScreenSizeConditional>
        );
    }

    private renderDropdown = (dropdown: IExpandable, id: string) => {
        // By setting defaultActiveElement=".bolt-tab", we are attempting to ensure
        // that the first tab in the MyWorkFlyout's TabBar gets focus.
        return (
            <WrappedComponent
                contentClassName="flyout-my-work"
                defaultActiveElement=".bolt-tab"
                dependencies={["ms.vss-features.ui-layer-content"]}
                id={id}
                modal={false}
                onDismiss={dropdown.collapse}
                wrappedType="customPanel"
            >
                <WrappedComponent wrappedType="vertical-header-my-work-flyout" />
            </WrappedComponent>
        );
    };
}

VssComponent.register("ms.vss-tfs-web.my-work", MyWork);
